/**
 * @generated SignedSource<<bee17ff24628f943d95588561448157f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ToggleGoogleSSOInput = {
  enableGoogleSSO?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type ToggleGoogleSSOMutation$variables = {
  input: ToggleGoogleSSOInput;
};
export type ToggleGoogleSSOMutation$data = {
  readonly toggleGoogleSSO: {
    readonly company: {
      readonly googleSSOEnabled: boolean | null;
    } | null;
  } | null;
};
export type ToggleGoogleSSOMutation = {
  variables: ToggleGoogleSSOMutation$variables;
  response: ToggleGoogleSSOMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "googleSSOEnabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ToggleGoogleSSOMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ToggleGoogleSSOPayload",
        "kind": "LinkedField",
        "name": "toggleGoogleSSO",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ToggleGoogleSSOMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ToggleGoogleSSOPayload",
        "kind": "LinkedField",
        "name": "toggleGoogleSSO",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "21f9a9c19994d12e196d2c46b4b2ddc7",
    "id": null,
    "metadata": {},
    "name": "ToggleGoogleSSOMutation",
    "operationKind": "mutation",
    "text": "mutation ToggleGoogleSSOMutation(\n  $input: ToggleGoogleSSOInput!\n) {\n  toggleGoogleSSO(input: $input) {\n    company {\n      googleSSOEnabled\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1ea888dc4fab1dbb6f2cc143d0ca6294";

export default node;
